import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation(); // Get the current location

  const [role, setRole] = useState(""); // State to store user role

  useEffect(() => {
    setRole(localStorage.getItem("role"));
  }, []);

  const handleToggleSidebar = () => {
    // Your toggle sidebar logic here
    window.clickToggleSidebarIcon();
    console.log("Sidebar toggled!");
  };

  return (
    <div className="sidebar" id="main-sidebar" data-background-color="dark">
      <div className="sidebar-logo">
        <div className="logo-header" data-background-color="dark">
          <Link to="/dashboard" className="logo">
            <img
              src="/icon/sidebar-icon-white.png"
              alt="navbar brand"
              className="navbar-brand"
              height="45"
            />
          </Link>
          <div
            className="nav-toggle cursor-pointer"
            onClick={handleToggleSidebar}
          >
            <button className="btn btn-toggle toggle-sidebar">
              <i className="gg-menu-right"></i>
            </button>
            <button className="btn btn-toggle sidenav-toggler">
              <i className="gg-menu-left"></i>
            </button>
          </div>
          <button className="topbar-toggler more">
            <i className="gg-more-vertical-alt"></i>
          </button>
        </div>
      </div>
      <div className="sidebar-wrapper scrollbar scrollbar-inner">
        <div className="sidebar-content">
          <ul className="nav nav-secondary">
            {role === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/dashboard" ? "active" : ""
                }`}
              >
                <Link to="/user/dashboard">
                  <i className="fas fa-home"></i>
                  <p>Dashboard</p>
                </Link>
              </li>
            )}
            {role === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/users" ? "active" : ""
                }`}
              >
                <Link to="/user/users">
                  <i className="fas fa-user"></i>
                  <p>Moderators</p>
                </Link>
              </li>
            )}

            {role === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/events" ? "active" : ""
                }`}
              >
                <Link to="/user/events">
                  <i className="fas fa-calendar-alt"></i>
                  <p>Events</p>
                </Link>
              </li>
            )}

              <li
                className={`nav-item ${
                  location.pathname === "/user/moderate" ? "active" : ""
                }`}
              >
                <Link to="/user/moderate">
                  <i className="fas fa-layer-group"></i>
                  <p>Moderate</p>
                </Link>
              </li>

            {role === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/ads" ? "active" : ""
                }`}
              >
                <Link to="/user/ads">
                  <i className="fas fa-bullhorn"></i>
                  <p>Ads</p>
                </Link>
              </li>
            )}

            {role === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/ads-group" ? "active" : ""
                }`}
              >
                <Link to="/user/ads-group">
                  {/* <i className="fas fa-bullhorn"></i> */}
                  <i className="far fa-object-group"></i>
                  <p>Ads Programs</p>
                </Link>
              </li>
            )}

            {role === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/scripts" ? "active" : ""
                }`}
              >
                <Link to="/user/scripts">
                  {/* <i className="fas fa-bullhorn"></i> */}
                  <i className="fas fa-code"></i>
                  <p>Scripts</p>
                </Link>
              </li>
            )}


            <li
              className={`nav-item d-none ${
                location.pathname === "/user/library" ? "active" : ""
              }`}
            >
              <Link to="/user/events">
                <i className="fas fa-chart-bar"></i>
                <p>Analytics</p>
              </Link>
            </li>
            <li
              className={`nav-item d-none ${
                location.pathname === "/user/playlists" ? "active" : ""
              }`}
            >
              <Link to="/user/events">
                <i className="fas fa-link"></i>
                <p>Integrations</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/user/account-settings" ? "active" : ""
              }`}
            >
              <Link to="/user/account-settings">
                <i className="fas fa-cog"></i>
                <p>Account Settings</p>
              </Link>
            </li>
            <li
              className={`nav-item d-none ${
                location.pathname === "/user/feedback" ? "active" : ""
              }`}
            >
              <Link to="/user/events">
                <i className="fas fa-comment"></i>
                <p>Support</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              <a href="/logout">
                <i className="fas fa-sign-out-alt"></i>
                <p>Logout</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
